var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("taskModuleRules.editElseActions"),
        width: "800px",
        footer: null,
        bodyStyle: { padding: "24px" },
      },
      on: { cancel: _vm.onCancel },
    },
    [
      _c(
        "div",
        { staticClass: "else-actions-editor" },
        [
          _c("p", { staticClass: "info-text" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t("taskModuleRules.defineActionsWhenNoRuleMatches")
                ) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("ActionsEditor", {
            attrs: { "when-type": "else", "workflow-id": _vm.workflowId },
            model: {
              value: _vm.localActions,
              callback: function ($$v) {
                _vm.localActions = $$v
              },
              expression: "localActions",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer-actions" },
            [
              _c("a-button", { on: { click: _vm.onCancel } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("auto.cancel")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("auto.save")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }